<script>
    export let id;
    export let title;
    export let dropdown_options;
    export let dropdown_available_options;
    export let dropdown_selected;

    import TitleDropdown from './TitleDropdown.svelte';
</script>

<div class="graph-title">
    {title}
    <TitleDropdown 
        {id}
        options={dropdown_options}
        available_options={dropdown_available_options}
        bind:selected={dropdown_selected}
    />
</div>

<style>
    .graph-title {
        color: #777;
        font-size: 16px;
        font-weight: 700;
        padding-bottom: 16px;
    }
</style>